module.exports = __webpack_public_path__ + "img/A.de8d2450.jpg";